import { actions } from './schedulesCabinet/actions'
import { getters } from './schedulesCabinet/getters'
import { state } from './schedulesCabinet/state'
import { mutations } from './schedulesCabinet/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
